import React, { Component } from "react";
import JobTrackIframeEmbed from "components/common/JobTrackIframeEmbed";
import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";

class IframeCostGroup extends Component {
  render() {
    const JobTrackAuthToken = StorageGateway.get("JobTrackBearerToken");
    const JobTrackRefreshToken = StorageGateway.get("jobTrackRefreshToken");

    const orgId = StorageGateway.get("jobTrackOrgId");
    const jwtToken = StorageGateway.get("iframe_jwt_token");
    return (
      <TwoColumnLayout hideFooter={true}>
        <JobTrackIframeEmbed
          src={`${process.env.REACT_APP_JOBTRAKS_BASE_URL}screen/93/Cost%20Groups?access_token=${JobTrackAuthToken}&refresh_token=${JobTrackRefreshToken}&jwt_token=${jwtToken}&jwt_expiry=3600&orgId=${orgId}&embed=true`}
        />
      </TwoColumnLayout>
    );
  }
}

export default IframeCostGroup;
